module.exports = __webpack_public_path__ + "img/upload-file-icon-topic.beac411d.svg";